import { motion } from "framer-motion";

export const LOVABLE_URL = "https://lovable.dev";
export const EMERGENT_URL =
  "https://afflat3b2.com/trk/lnk/810438E9-880D-4D45-BB97-8BF27FEF6B20/?o=32675&c=918277&a=773258&k=BC6A2957816554B8B2E68FA547239CA8&l=38550";

export const scrollToId = (id) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(id, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 44 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ index, label, testId }) => (
  <Reveal className="mb-6 flex items-center gap-4">
    <span className="font-mono2 text-[11px] font-medium tracking-[0.35em] text-cyan-300/90">
      {index}
    </span>
    <span className="h-px w-10 bg-gradient-to-r from-cyan-400/70 to-transparent" />
    <span
      data-testid={testId}
      className="font-mono2 text-[11px] uppercase tracking-[0.35em] text-slate-500"
    >
      {label}
    </span>
  </Reveal>
);

export const SectionTitle = ({ children, className = "" }) => (
  <Reveal>
    <h2
      className={`font-display text-[1.4rem] font-bold tracking-tight text-white sm:text-3xl lg:text-4xl ${className}`}
    >
      {children}
    </h2>
  </Reveal>
);

export const SectionSub = ({ children, className = "" }) => (
  <Reveal delay={0.08}>
    <p className={`mt-4 max-w-2xl text-base text-slate-400 md:text-lg ${className}`}>
      {children}
    </p>
  </Reveal>
);

export const LovableLogo = ({ size = 44 }) => (
  <img
    src="/assets/lovable-logo.png"
    alt="Lovable logo"
    width={size}
    height={size}
    style={{
      width: Math.round(size * 0.82),
      height: Math.round(size * 0.82),
      margin: Math.round(size * 0.09),
      filter:
        "drop-shadow(0 0 6px rgba(255,92,138,0.45)) drop-shadow(0 0 14px rgba(255,45,85,0.35))",
    }}
  />
);

export const EmergentLogo = ({ size = 44 }) => (
  <img
    src="/assets/emergent-logo.png"
    alt="Emergent logo"
    width={size}
    height={size}
    style={{
      width: size,
      height: size,
      filter:
        "drop-shadow(0 0 6px rgba(255,255,255,0.35)) drop-shadow(0 0 14px rgba(34,211,238,0.35))",
    }}
  />
);
